import React, { useEffect, useState } from 'react';
import { CONCIERGE_EDIT, HOUSE_KEEPING_TAB_LIST } from '../../../../../constants/ServiceConstants';
import {
  RBAC_PERMISSION_LEVEL_FULL_ACCESS,
  RBAC_TYPE_SERVICES_SERVICE_REQUEST,
} from '../../../../../constants/RoleConsts';
import MediaViewer from '../../../../../shared/media-viewer/MediaViewer';
import DetailViewLayout from '../../../../../shared/detail-view-layout/Detail-View-Layout';
import './ConciergeView.scss';
import { Accordion, AccordionDetails, AccordionSummary } from '@material-ui/core';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import moment from 'moment';
import { allConcierge } from '../../../servicesSlice';
import { useSelector } from 'react-redux';
import { decodeMediaKeyValue } from '../../../../../utils/mediaUtils';

const ConciergeView = (props) => {
  const { onViewToggle, object, onDrawerToggle, permissions } = props;
  const [tabValue, setTabValue] = useState(0);
  const handleTabChange = (event, newValue) => {
    setTabValue(newValue);
  };
  const [obj, setObj] = useState();
  const allConciergeSelector = useSelector(allConcierge);

  useEffect(() => {
    if (allConciergeSelector.length) {
      let conciergeObj = {
        ...allConciergeSelector.find((info) => info.id === object.id),
      };
      setObj(conciergeObj);
    }
  }, [allConciergeSelector]);

  const onOpenDrawer = (event) => {
    event.stopPropagation();
    onDrawerToggle(CONCIERGE_EDIT, true, obj);
  };

  const renderScreen = () => {
    return (
      <>
        {tabValue === 0 && (
          <div>
            <div className='row mx-4 mt-3'>
              <div className='col-md-4'>
                <div className='details-label'>Service Name</div>
                <div className='details-value preview-breaks'>{obj.name}</div>
              </div>
              <div className='col-md-8'>
                <div className='details-label'>Service Code</div>
                <div className='details-value'>{obj.code ? obj.code : '---'}</div>
              </div>
            </div>
            <div className='row mx-4 mt-3'>
              <div className='col-fluid'>
                <div className='details-label'>Description</div>
                <div className='details-value preview-breaks'>
                  {obj.description ? obj.description : '---'}
                </div>
              </div>
            </div>
            <div className='row mx-4 mt-3'>
              <div className='col-md-6'>
                <div className='details-label'>Confirmation Message</div>
                <div className='details-value'>
                  {obj.confirmationMessage ? obj.confirmationMessage : '---'}
                </div>
              </div>
            </div>
            <div className='row mx-4 mt-3'>
              <div className='col-md-6'>
                <div className='details-label'>Max Quantity</div>
                <div className='details-value'>
                  {obj.maxQuantity && obj.maxQuantityActive ? obj.maxQuantity : 'NA'}
                </div>
              </div>
            </div>
            <div className='row mx-4 mt-3'>
              <div className='col-md-6'>
                <div className='details-label'>Schedule</div>
                {obj.schedule?.length > 0
                  ? obj.schedule.map((sched, i) => (
                      <div key={i} className='details-value'>
                        {sched === 'CUSTOM'
                          ? sched.charAt(0).toUpperCase() +
                            sched.slice(1).toLowerCase() +
                            ' - ' +
                            obj.customSchedule
                          : sched.charAt(0).toUpperCase() + sched.slice(1).toLowerCase()}
                      </div>
                    ))
                  : 'NA'}
              </div>
            </div>
          </div>
        )}
        {tabValue === 1 && (
          <div className='row mx-4 mt-3 overflow-auto h-100 accordion-div-concierge'>
            <div className='col-md-12'>
              <div className='details-label'>Items</div>
              {obj.isItemActive ? (
                <div>
                  <div className='details-value'>
                    {obj?.items[0]?.name ? obj?.items?.length : 'NA'}
                  </div>
                  <div className='col-md-12 '>
                    {obj.items.length > 0 &&
                      obj.items[0].name &&
                      obj.items.map((item, i) => (
                        <div className='row mt-3' key={i}>
                          <div className='col-md-12 bg-info p-2'>
                            <Accordion>
                              <AccordionSummary
                                expandIcon={<ExpandMoreIcon />}
                                aria-controls='panel1a-content'
                                id='panel1a-header'
                              >
                                <div className='mt-1'>
                                  <div>
                                    <span className='details-label'>Item Name: </span>
                                    <span className='details-value'>{item.name}</span>
                                  </div>
                                </div>
                              </AccordionSummary>
                              <AccordionDetails>
                                <div className='col-12 pe-3'>
                                  <div className='row'>
                                    <div>
                                      <div className='details-label'>
                                        <span>Item</span> <span>Code</span>
                                      </div>
                                      <div className='details-value'>
                                        {item.id ? item.id : '---'}
                                      </div>
                                    </div>
                                  </div>
                                  <div className='row mt-3'>
                                    <div className='col-fluid'>
                                      <div className='details-label'>Description</div>
                                      <div className='details-value'>
                                        {item.description ? item.description : '---'}
                                      </div>
                                    </div>
                                  </div>
                                  <div className='row mt-3'>
                                    <div className='col-fluid'>
                                      <div className='details-label'>Type</div>
                                      <div className='details-value'>
                                        {item.itemDataType ? item.itemDataType.charAt(0).toUpperCase() + item.itemDataType.slice(1) : '---'}
                                      </div>
                                    </div>
                                  </div>
                                  <div className='row mt-3'>
                                    <div className='col-fluid'>
                                      <div className='details-label'>Max Quantity</div>
                                      <div className='details-value'>
                                        {item.maxQuantity && item.maxQuantityActive
                                          ? item.maxQuantity
                                          : 'NA'}
                                      </div>
                                    </div>
                                  </div>
                                  <div className='row mt-3'>
                                    <div className='col-fluid'>
                                      <div className='details-label'>Status</div>
                                      <div className='details-value'>
                                        {item?.isActive ? 'Active' : 'Inactive'}
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </AccordionDetails>
                            </Accordion>
                          </div>
                        </div>
                      ))}
                  </div>
                </div>
              ) : (
                'NA'
              )}
            </div>
          </div>
        )}
        {tabValue === 2 && (
          <div>
            {obj?.hours?.length > 0 ? (
              obj?.hours[0]?.everyday && obj?.hours[0]?.allTime ? (
                <div>
                  <div className='row mx-4 mt-3'>
                    <div className='col-md-6'>
                      <div className='details-label'>Available On</div>
                      <div className='details-value'>Everyday</div>
                    </div>
                  </div>
                  <div className='row mx-4 mt-4'>
                    <div className='col-md-6'>
                      <div className='details-label'>Hours</div>
                      <div className='details-value'>24*7</div>
                    </div>
                  </div>
                </div>
              ) : (
                <div className='row mx-4 mt-3'>
                  <div className='col-md-6'>
                    <div className='details-label'>Open on</div>
                    <div className='details-value'>
                      {obj.hours.map((hour) => (
                        <div className='d-flex'>
                          <div className='me-1'>
                            {hour.everyday
                              ? 'Everyday :'
                              : hour?.day
                                  .map(
                                    (h) =>
                                      ` ${h.substring(0, 1).toUpperCase()}${h
                                        .substring(1, 3)
                                        .toLowerCase()}`,
                                  )
                                  .join(', ') + ' :'}
                          </div>
                          <div>
                            {hour.allTime
                              ? '24*7'
                              : moment(hour.open, 'HH:mm').format('LT') +
                                ' - ' +
                                moment(hour.close, 'HH:mm').format('LT')}
                          </div>
                        </div>
                      ))}
                    </div>
                  </div>
                </div>
              )
            ) : (
              <div className='row mx-4 mt-3'>
                <div className='col-md-12'>
                  <div className='details-label'>No hours details available</div>
                </div>
              </div>
            )}
          </div>
        )}
        {tabValue === 3 && (
          <div className='row mx-4 mt-3'>
              <MediaViewer
                images={obj?.images || []}
                videos={(() => {
                  const { Video: videoMediaContent } = decodeMediaKeyValue(obj?.mediaContent);
                  return videoMediaContent || obj?.videos || {};
                })()}
                gifs={(() => {
                  const { GIF: gifMediaContent } = decodeMediaKeyValue(obj?.mediaContent);
                  return gifMediaContent || obj?.gifs || {};
                })()}
              />
            </div>
        )}
      </>
    );
  };

  return (
    <>
      {obj && (
        <DetailViewLayout
          onClickEdit={onOpenDrawer}
          renderScreen={renderScreen}
          handleTabChange={handleTabChange}
          tabValue={tabValue}
          tabList={HOUSE_KEEPING_TAB_LIST}
          onViewToggle={onViewToggle}
          title={obj.name}
          createdUserId={obj.createdBy}
          isEditable={
            permissions[RBAC_TYPE_SERVICES_SERVICE_REQUEST] === RBAC_PERMISSION_LEVEL_FULL_ACCESS
          }
          tabClass='col-md-6'
        />
      )}
    </>
  );
};

export default ConciergeView;
